import IS_CLIENT_RENDERED from "./isClientRendered";

export const back = () => {
  if (IS_CLIENT_RENDERED) {
    window.history.back();
  }
};

export const pushState = (data, path, title = "") => {
  if (IS_CLIENT_RENDERED) {
    window.history.pushState(data, title, path);
  }
};



// WEBPACK FOOTER //
// ./src/util/windowHistory.js